// @flow
/**
 * Created by Dirk-Jan Rutten on 01/11/16.
 */

import React from "react";
import { parseDate, parseAmount, formatPrice } from "../../../../../utils";

import { gql } from "@apollo/client";
import { colors } from "../../../../../styling/index";
import Paper from "material-ui/Paper";
import { Frequency } from "generated/graphql";
import { formatFrequency2 } from "utils/formatter";
import { Button } from "@mui/material";

const styles: { [key: string]: React.CSSProperties } = {
  paperElement: {
    height: "100%",
    width: "100%",
    textAlign: "center",
    paddingTop: "20px",
    paddingLeft: "28px",
    paddingRight: "28px",
    paddingBottom: "28px",
    fontWeight: 300,
    fontSize: "16px",
  },
  personInfoRowContainer: {
    paddingTop: "12px",
    marginLeft: "10px",
    marginRight: "10px",
    textAlign: "left",
  },
  personInfoText: {
    display: "flex",
    alignItems: "flex-end",
  },
  policyInfoRowContainer: {
    paddingTop: "12px",
    marginLeft: "40px",
    marginRight: "10px",
    textAlign: "left",
  },
  policyInfoLabel: {
    display: "flex",
    alignItems: "center",
    color: colors.lightGrey,
  },
  icon: {
    width: "16px",
    height: "16px",
  },
};

type PolicyState =
  | "PENDING"
  | "ACTIVE"
  | "CANCELLED"
  | "DEAD"
  | "ACCEPTED"
  | "REJECTED"
  | "DISCHARGE";
type Props = {
  data: {
    id: string;
    premium: number;
    state: PolicyState;
    signupDate: string;
    package: {
      id: string;
      name: string;
    };
    frequency: Frequency;
  };
  onDetails: (policyId: string) => void;
};

function toDutchPolicyState(state: PolicyState) {
  switch (state) {
    case "PENDING":
      return "In afwachting";
    case "ACCEPTED":
      return "Geaccepteerd";
    case "REJECTED":
      return "Afgewezen";
    case "ACTIVE":
      return "Actief";
    case "DEAD":
      return "Overleden";
    case "CANCELLED":
      return "Opgezegd";
    case "DISCHARGE":
      return "Geroyeerd";
    default:
      return state;
  }
}

function propsMapper(props: Props) {
  let infoArray = [
    { info: props.data.package.name, text: "Pakket" },
    {
      info:
        formatPrice(parseAmount(props.data.premium)) +
        " " +
        formatFrequency2(props.data.frequency).toLowerCase(),
      text: "Contributie",
    },
    {
      info: toDutchPolicyState(props.data.state),
      text: "Status",
    },
    { info: parseDate(props.data.signupDate), text: "Lid sinds" },
  ];

  return infoArray.map(function (object) {
    return (
      <div
        key={object.text}
        style={{ display: "flex", ...styles.policyInfoRowContainer }}
      >
        <div style={{ flex: 1, ...styles.policyInfoLabel }}>{object.text}</div>
        <div style={{ flex: 1 }}>{object.info}</div>
      </div>
    );
  });
}

export const MultiPolicyCardFragment = gql`
  fragment multiPolicyCard on Policy {
    id
    package {
      id
      name
    }
    premium
    frequency
    signupDate
    state
  }
`;

/**
 * Represents a 'card' that contains the data for a single policy.
 */
const MultiPolicyCard = (props: Props) => (
  <Paper style={styles.paperElement}>
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div style={{ flex: 3 }}>{propsMapper(props)}</div>
      <div style={{ flex: 1 }}>
        <Button
          onClick={() => {
            props.onDetails(props.data.id);
          }}
        >
          DETAILS
        </Button>
      </div>
    </div>
  </Paper>
);

export default MultiPolicyCard;
